import React from "react";
import styled from "styled-components";
import { Paragraph14Regular } from "../../../../../common/Typography/Paragraph14";
import Icon from "../../../../../common/components/Icon/Icon";

const Container = styled.div`
  display: flex;
  padding-bottom: 39px;
`;

const Description = styled(Paragraph14Regular)`
  font-size: ${({ theme }) => theme.paragraph.md};
  opacity: 0.7;
`;

const InfoIcon = styled(Icon)`
  transform: translateY(-2px);
  padding-right: 6px;
  opacity: 0.7;
`;

const SingupBoxInfoMobile = (props: any) => {
  const { children } = props;
  return (
    <Container>
      <div>
        <InfoIcon name="info" width="24px" height="24px" />
      </div>
      <Description>{children}</Description>
    </Container>
  );
};

export default SingupBoxInfoMobile;
